import { useQuery } from "@tanstack/react-query"
import { request } from "./config"

// tog'a #3473/#3481 (2026-10-04): bo'lim va menyu guruhi nomi TIZIM ICHIDA (Роли → «Разделы системы» → ✏).
// O'zgartirilgan nom hamma tilda va hamma joyda ustun: chap menyu, sahifa sarlavhasi, «Роли», telefon (server tomonda).
// Kalit — marshrut bo'lagi (sahifa-huquq ResourceName) yoki «group:<guruh kaliti>»; qidiruv kichik harfda.
export const SECTION_NAMES_KEY = ["SECTION_NAMES"]
export const sectionGroupKey = (groupKey: string) => "group:" + groupKey

export function useSectionNames(enabled = true): Record<string, string> {
  const { data } = useQuery(
    SECTION_NAMES_KEY,
    async () => {
      const rows = (await request({ url: "SectionNames" })).data || []
      const map: Record<string, string> = {}
      for (const r of rows) if (r?.key && r?.name) map[String(r.key).toLowerCase()] = String(r.name)
      return map
    },
    { enabled, staleTime: 5 * 60 * 1000, retry: false, refetchOnWindowFocus: false }
  )
  return data || {}
}

/** Marshrutdan (masalan «/wallet» yoki «/orders/123») bo'lim kaliti. */
export function sectionKeyOfRoute(route?: string): string {
  return String(route || "").split("/")[1]?.toLowerCase() || ""
}
